import { render, staticRenderFns } from "./VxBasicIcon.vue?vue&type=template&id=0b6d08b9&scoped=true"
import script from "./VxBasicIcon.vue?vue&type=script&lang=js"
export * from "./VxBasicIcon.vue?vue&type=script&lang=js"
import style0 from "./VxBasicIcon.vue?vue&type=style&index=0&id=0b6d08b9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b6d08b9",
  null
  
)

export default component.exports